import { render, staticRenderFns } from "./materialQuestions.vue?vue&type=template&id=1e9b0e28&scoped=true&"
import script from "./materialQuestions.vue?vue&type=script&lang=js&"
export * from "./materialQuestions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e9b0e28",
  null
  
)

export default component.exports